[
  [
    {
      "id": "decompose",
      "title": "Decompose (HB)",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:decompose"
    },
    {
      "id": "guidance",
      "title": "Guidance",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:guidance"
    },
    {
      "id": "hand-of-radiance",
      "title": "Hand of Radiance (UA)",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:hand-of-radiance"
    },
    {
      "id": "light",
      "title": "Light",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:light"
    },
    {
      "id": "mending",
      "title": "Mending",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:mending"
    },
    {
      "id": "resistance",
      "title": "Resistance",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:resistance"
    },
    {
      "id": "sacred-flame",
      "title": "Sacred Flame",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:sacred-flame"
    },
    {
      "id": "spare-the-dying",
      "title": "Spare the Dying",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:spare-the-dying"
    },
    {
      "id": "thaumaturgy",
      "title": "Thaumaturgy",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:thaumaturgy"
    },
    {
      "id": "toll-the-dead",
      "title": "Toll the Dead",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:toll-the-dead"
    },
    {
      "id": "virtue",
      "title": "Virtue (UA)",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:virtue"
    },
    {
      "id": "word-of-radiance",
      "title": "Word of Radiance",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:word-of-radiance"
    }
  ],
  [
    {
      "id": "bane",
      "title": "Bane",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:bane"
    },
    {
      "id": "bless",
      "title": "Bless",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:bless"
    },
    {
      "id": "ceremony",
      "title": "Ceremony",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:ceremony"
    },
    {
      "id": "command",
      "title": "Command",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:command"
    },
    {
      "id": "create-or-destroy-water",
      "title": "Create or Destroy Water",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:create-or-destroy-water"
    },
    {
      "id": "cure-wounds",
      "title": "Cure Wounds",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:cure-wounds"
    },
    {
      "id": "detect-evil-and-good",
      "title": "Detect Evil and Good",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:detect-evil-and-good"
    },
    {
      "id": "detect-magic",
      "title": "Detect Magic",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:detect-magic"
    },
    {
      "id": "detect-poison-and-disease",
      "title": "Detect Poison and Disease",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:detect-poison-and-disease"
    },
    {
      "id": "guiding-bolt",
      "title": "Guiding Bolt",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:guiding-bolt"
    },
    {
      "id": "guiding-hand-ua",
      "title": "Guiding Hand (UA)",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:guiding-hand-ua"
    },
    {
      "id": "healing-word",
      "title": "Healing Word",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:healing-word"
    },
    {
      "id": "inflict-wounds",
      "title": "Inflict Wounds",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:inflict-wounds"
    },
    {
      "id": "protection-from-evil-and-good",
      "title": "Protection from Evil and Good",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:protection-from-evil-and-good"
    },
    {
      "id": "purify-food-and-drink",
      "title": "Purify Food and Drink",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:purify-food-and-drink"
    },
    {
      "id": "sanctuary",
      "title": "Sanctuary",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:sanctuary"
    },
    {
      "id": "shield-of-faith",
      "title": "Shield of Faith",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:shield-of-faith"
    }
  ],
  [
    {
      "id": "aid",
      "title": "Aid",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:aid"
    },
    {
      "id": "augury",
      "title": "Augury",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:augury"
    },
    {
      "id": "blindness-deafness",
      "title": "Blindness/Deafness",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:blindness-deafness"
    },
    {
      "id": "borrowed-knowledge",
      "title": "Borrowed Knowledge",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:borrowed-knowledge"
    },
    {
      "id": "calm-emotions",
      "title": "Calm Emotions",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:calm-emotions"
    },
    {
      "id": "continual-flame",
      "title": "Continual Flame",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:continual-flame"
    },
    {
      "id": "enhance-ability",
      "title": "Enhance Ability",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:enhance-ability"
    },
    {
      "id": "find-traps",
      "title": "Find Traps",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:find-traps"
    },
    {
      "id": "gentle-repose",
      "title": "Gentle Repose",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:gentle-repose"
    },
    {
      "id": "hold-person",
      "title": "Hold Person",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:hold-person"
    },
    {
      "id": "lesser-restoration",
      "title": "Lesser Restoration",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:lesser-restoration"
    },
    {
      "id": "locate-object",
      "title": "Locate Object",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:locate-object"
    },
    {
      "id": "prayer-of-healing",
      "title": "Prayer of Healing",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:prayer-of-healing"
    },
    {
      "id": "protection-from-poison",
      "title": "Protection from Poison",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:protection-from-poison"
    },
    {
      "id": "silence",
      "title": "Silence",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:silence"
    },
    {
      "id": "spiritual-weapon",
      "title": "Spiritual Weapon",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:spiritual-weapon"
    },
    {
      "id": "warding-bond",
      "title": "Warding Bond",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:warding-bond"
    },
    {
      "id": "zone-of-truth",
      "title": "Zone of Truth",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:zone-of-truth"
    }
  ],
  [
    {
      "id": "animate-dead",
      "title": "Animate Dead",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:animate-dead"
    },
    {
      "id": "aura-of-vitality",
      "title": "Aura of Vitality",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:aura-of-vitality"
    },
    {
      "id": "beacon-of-hope",
      "title": "Beacon of Hope",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:beacon-of-hope"
    },
    {
      "id": "bestow-curse",
      "title": "Bestow Curse",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:bestow-curse"
    },
    {
      "id": "clairvoyance",
      "title": "Clairvoyance",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:clairvoyance"
    },
    {
      "id": "create-food-and-water",
      "title": "Create Food and Water",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:create-food-and-water"
    },
    {
      "id": "daylight",
      "title": "Daylight",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:daylight"
    },
    {
      "id": "dispel-magic",
      "title": "Dispel Magic",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:dispel-magic"
    },
    {
      "id": "fast-friends",
      "title": "Fast Friends",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:fast-friends"
    },
    {
      "id": "feign-death",
      "title": "Feign Death",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:feign-death"
    },
    {
      "id": "glyph-of-warding",
      "title": "Glyph of Warding",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:glyph-of-warding"
    },
    {
      "id": "incite-greed",
      "title": "Incite Greed",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:incite-greed"
    },
    {
      "id": "life-transference",
      "title": "Life Transference",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:life-transference"
    },
    {
      "id": "magic-circle",
      "title": "Magic Circle",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:magic-circle"
    },
    {
      "id": "mass-healing-word",
      "title": "Mass Healing Word",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:mass-healing-word"
    },
    {
      "id": "meld-into-stone",
      "title": "Meld into Stone",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:meld-into-stone"
    },
    {
      "id": "motivational-speech",
      "title": "Motivational Speech",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:motivational-speech"
    },
    {
      "id": "protection-from-energy",
      "title": "Protection from Energy",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:protection-from-energy"
    },
    {
      "id": "remove-curse",
      "title": "Remove Curse",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:remove-curse"
    },
    {
      "id": "revivify",
      "title": "Revivify",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:revivify"
    },
    {
      "id": "sending",
      "title": "Sending",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:sending"
    },
    {
      "id": "speak-with-dead",
      "title": "Speak with Dead",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:speak-with-dead"
    },
    {
      "id": "spirit-guardians",
      "title": "Spirit Guardians",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:spirit-guardians"
    },
    {
      "id": "spirit-shroud",
      "title": "Spirit Shroud",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:spirit-shroud"
    },
    {
      "id": "tongues",
      "title": "Tongues",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:tongues"
    },
    {
      "id": "water-walk",
      "title": "Water Walk",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:water-walk"
    }
  ],
  [
    {
      "id": "aura-of-life",
      "title": "Aura of Life",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:aura-of-life"
    },
    {
      "id": "aura-of-purity",
      "title": "Aura of Purity",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:aura-of-purity"
    },
    {
      "id": "banishment",
      "title": "Banishment",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:banishment"
    },
    {
      "id": "control-water",
      "title": "Control Water",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:control-water"
    },
    {
      "id": "death-ward",
      "title": "Death Ward",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:death-ward"
    },
    {
      "id": "divination",
      "title": "Divination",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:divination"
    },
    {
      "id": "freedom-of-movement",
      "title": "Freedom of Movement",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:freedom-of-movement"
    },
    {
      "id": "guardian-of-faith",
      "title": "Guardian of Faith",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:guardian-of-faith"
    },
    {
      "id": "locate-creature",
      "title": "Locate Creature",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:locate-creature"
    },
    {
      "id": "stone-shape",
      "title": "Stone Shape",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:stone-shape"
    }
  ],
  [
    {
      "id": "commune",
      "title": "Commune",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:commune"
    },
    {
      "id": "contagion",
      "title": "Contagion",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:contagion"
    },
    {
      "id": "dawn",
      "title": "Dawn",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:dawn"
    },
    {
      "id": "dispel-evil-and-good",
      "title": "Dispel Evil and Good",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:dispel-evil-and-good"
    },
    {
      "id": "flame-strike",
      "title": "Flame Strike",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:flame-strike"
    },
    {
      "id": "geas",
      "title": "Geas",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:geas"
    },
    {
      "id": "greater-restoration",
      "title": "Greater Restoration",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:greater-restoration"
    },
    {
      "id": "hallow",
      "title": "Hallow",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:hallow"
    },
    {
      "id": "holy-weapon",
      "title": "Holy Weapon",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:holy-weapon"
    },
    {
      "id": "insect-plague",
      "title": "Insect Plague",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:insect-plague"
    },
    {
      "id": "legend-lore",
      "title": "Legend Lore",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:legend-lore"
    },
    {
      "id": "mass-cure-wounds",
      "title": "Mass Cure Wounds",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:mass-cure-wounds"
    },
    {
      "id": "planar-binding",
      "title": "Planar Binding",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:planar-binding"
    },
    {
      "id": "raise-dead",
      "title": "Raise Dead",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:raise-dead"
    },
    {
      "id": "scrying",
      "title": "Scrying",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:scrying"
    },
    {
      "id": "summon-celestial",
      "title": "Summon Celestial",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:summon-celestial"
    }
  ],
  [
    {
      "id": "blade-barrier",
      "title": "Blade Barrier",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:blade-barrier"
    },
    {
      "id": "create-undead",
      "title": "Create Undead",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:create-undead"
    },
    {
      "id": "find-the-path",
      "title": "Find the Path",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:find-the-path"
    },
    {
      "id": "forbiddance",
      "title": "Forbiddance",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:forbiddance"
    },
    {
      "id": "harm",
      "title": "Harm",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:harm"
    },
    {
      "id": "heal",
      "title": "Heal",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:heal"
    },
    {
      "id": "heroes-feast",
      "title": "Heroes' Feast",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:heroes-feast"
    },
    {
      "id": "otherworldly-form",
      "title": "Otherworldly Form (UA)",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:otherworldly-form"
    },
    {
      "id": "planar-ally",
      "title": "Planar Ally",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:planar-ally"
    },
    {
      "id": "sunbeam",
      "title": "Sunbeam",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:sunbeam"
    },
    {
      "id": "true-seeing",
      "title": "True Seeing",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:true-seeing"
    },
    {
      "id": "word-of-recall",
      "title": "Word of Recall",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:word-of-recall"
    }
  ],
  [
    {
      "id": "conjure-celestial",
      "title": "Conjure Celestial",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:conjure-celestial"
    },
    {
      "id": "divine-word",
      "title": "Divine Word",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:divine-word"
    },
    {
      "id": "etherealness",
      "title": "Etherealness",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:etherealness"
    },
    {
      "id": "fire-storm",
      "title": "Fire Storm",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:fire-storm"
    },
    {
      "id": "plane-shift",
      "title": "Plane Shift",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:plane-shift"
    },
    {
      "id": "regenerate",
      "title": "Regenerate",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:regenerate"
    },
    {
      "id": "resurrection",
      "title": "Resurrection",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:resurrection"
    },
    {
      "id": "symbol",
      "title": "Symbol",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:symbol"
    },
    {
      "id": "temple-of-the-gods",
      "title": "Temple of the Gods",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:temple-of-the-gods"
    }
  ],
  [
    {
      "id": "antimagic-field",
      "title": "Antimagic Field",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:antimagic-field"
    },
    {
      "id": "control-weather",
      "title": "Control Weather",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:control-weather"
    },
    {
      "id": "earthquake",
      "title": "Earthquake",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:earthquake"
    },
    {
      "id": "holy-aura",
      "title": "Holy Aura",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:holy-aura"
    },
    {
      "id": "sunburst",
      "title": "Sunburst",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:sunburst"
    }
  ],
  [
    {
      "id": "astral-projection",
      "title": "Astral Projection",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:astral-projection"
    },
    {
      "id": "gate",
      "title": "Gate",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:gate"
    },
    {
      "id": "mass-heal",
      "title": "Mass Heal",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:mass-heal"
    },
    {
      "id": "power-word-heal",
      "title": "Power Word: Heal",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:power-word-heal"
    },
    {
      "id": "true-resurrection",
      "title": "True Resurrection",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:true-resurrection"
    }
  ]
]
